export const IP = 'http://localhost:8000';
export const number = "3347259681";
export const configWhatsApp ="whatsapp://send?text=Ciao!&phone=+393347259681";
export const email = "arredobimbo@gmail.com"
export const numero_1="3347259681"
export const numero_2="0818734254"
export const indirizzo="Via Roma "
export const citta="Sant'Antonio Abate"
export const civico="17"
export const provincia="Napoli"